module.exports = __webpack_public_path__ + "img/wx-share.409e32dc.png";